import { ModuleWithProviders, NgModule } from '@angular/core';

import { ElFocusTrapFactoryService } from './focus-trap';
import { ElFocusKeyManagerFactoryService } from './focus-key-manager';

@NgModule({})
export class ElA11yModule {
  static forRoot() {
    return <ModuleWithProviders>{
      ngModule: ElA11yModule,
      providers: [
        ElFocusTrapFactoryService,
        ElFocusKeyManagerFactoryService,
      ],
    };
  }
}
